
import { defineComponent } from 'vue'
import { Flag } from './models/flag'
import { FlagFormData } from '@/controllers/flag-form-controller'
import FlagForm from './components/FlagForm.vue'
import FileDisplay from './components/FileDisplay.vue'
import NavBar from './components/NavBar.vue'
import Header from './components/Header.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.js'

export default defineComponent({
  name: 'App',
  components: {
    FlagForm,
    FileDisplay,
    NavBar,
    Header
  },
  data () {
    return {
      initialFlags: [FlagFormData.default()],
      flags: new Map<string, Flag>()
    }
  },
  methods: {
    updateFlags (flags: Array<FlagFormData>): void {
      const file = new Map<string, Flag>()
      flags.forEach(f => {
        file.set(f.name, f.toFlag())
      })
      this.flags = file
    }
  },
  index: 200
})
